import { camelToSnakeCase } from "../../utils/utils";

export const BANK_TRANSACTION_FILTER_FIELD_MAP: Record<string, string> = {};

export function mapBankTransactionFilterField(frontendField: string): string {
  const snakeCase = camelToSnakeCase(frontendField);
  return BANK_TRANSACTION_FILTER_FIELD_MAP[snakeCase] ?? snakeCase;
}

export function mapBankTransactionSortField(frontendField: string): string {
  return camelToSnakeCase(frontendField);
}
